<template>
  <div>
    <div class="header">
      <van-tabs background="rgba(128, 128, 128, 0.1)" v-model="activeName">
        <van-tab
          title="使用中"
          title-style="border: 0;
			border-radius: 20px;  "
          name="a"
        ></van-tab>
        <van-tab
          title="待生效"
          title-style="border: 0;
			border-radius: 20px; "
          name="b"
        ></van-tab>
        <van-tab
          title="已失效"
          title-style="border: 0;
			border-radius: 20px; "
          name="c"
        ></van-tab>
      </van-tabs>
    </div>
    <p style="font-size: 18px; font-weight: 600">卡号{{ card }}</p>
    <div class="detail">
      <Querys></Querys>
    </div>
  </div>
</template>

<script>
  import Querys from "@/components/Querys.vue";
  export default {
    name: "Query",
    data() {
      return {
        activeName: "a",
        card: "",
      };
    },
    created() {},
    mounted() {
      this.card = localStorage.getItem("meCardNum");
    },

    methods: {
      copy() {
        var e = document.getElementById("target");
        e.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        alert("内容复制成功！");
      },
    },
    components: {
      Querys,
    },
  };
</script>

<style lang="scss" scoped>
  .header {
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    background-color: white;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
  }
  .detail {
    padding: 5px;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.1);
  }
</style>
